import PropTypes from 'prop-types';

const SideNavigationMenu = ({ children }) => {
  return <div className="side-navigation-menu -ml-4 -mr-4">{children}</div>;
};

SideNavigationMenu.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SideNavigationMenu;
